import Container from '../container';

const styles =
  'min-w-0 mobile:max-w-[100%] tablet-lg:max-w-[75%] tablet-lg:max-w-[60%] mobile:p-2 tablet-lg:p-3 h-full text-sm';

const ROUNDING = {
  start: 'rounded-t-xl rounded-br-xl',
  'start-owned': 'rounded-t-xl rounded-bl-xl',
  end: 'rounded-b-xl rounded-tr-xl',
  'end-owned': 'rounded-b-xl rounded-tl-xl',
  inbetween: 'rounded-r-xl',
  'inbetween-owned': 'rounded-l-xl',
};

type MessageBubbleProps = {
  message: string;
  owned: boolean;
  variant:
    | 'start'
    | 'inbetween'
    | 'end'
    | 'start-owned'
    | 'inbetween-owned'
    | 'end-owned';
};

export function MessageBubble({ message, variant, owned }: MessageBubbleProps) {
  return (
    <Container
      extensions={`${styles} ${owned ? 'bg-secondary' : 'bg-[#2C2C2E]'} ${
        ROUNDING[variant]
      }`}
    >
      {message}
    </Container>
  );
}
